var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-columns',{attrs:{"is-multiline":""}},[_c('b-column',{staticClass:"is-full"},[_c('fire-fighting',{attrs:{"omit-fire-diamond":_vm.omitFireDiamond,"is-dense":_vm.isDense}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }